<template>
  <v-navigation-drawer
      app
      clipped
      v-model="LEFT_BUILDING_DRAWER_STATE"
      :mini-variant="isMini"
      permanent
      mini-variant-width="50"
      :class="{'drawer-mini': !LEFT_BUILDING_DRAWER_STATE}"
      class="mt-15 pb-15 mt-md-16 pb-md-16"
      width="400"
  >
    <div v-show="!isMini" class="text-right">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs}">
          <v-btn class="pa-5" icon @click.stop="TOOGLE_LEFT_BUILDING_DRAWER_STATE" v-bind="attrs" v-on="on">
            <v-icon color="primary">close</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('buttons:close-sidebar')}}</span>
      </v-tooltip>
    </div>
    <div v-show="isMini" class="text-center">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs}">
          <v-btn class="pa-5" icon @click.stop="TOOGLE_LEFT_BUILDING_DRAWER_STATE" v-bind="attrs" v-on="on">
            <v-icon color="primary">edit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('buttons:open-sidebar')}}</span>
      </v-tooltip>
    </div>


    <!-- Building Image + Building Image Uploader + Building Name -->
    <v-row v-show="!isMini" align="center" class="px-5">
      <v-col cols="12" lg="3">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs}">
            <v-btn
                @click="$refs.imageUpload.showDialog = true"
                text
                class="pa-0 "
                height="auto"
                v-bind="attrs"
                v-on="on"
            >
              <v-img
                  v-if="building.imagePath"
                  :src="building.imagePath"
                  aspect-ratio="1"
                  contain
              />

              <v-icon v-else class="sidebar-icon sidebar-icon-bg-light-blue" color="primary">apartment</v-icon>
              <v-icon class="edit-icon-svg" v-if="!building.imagePath">create</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('book/building:building.form-sidebar.building-image')}}</span>
        </v-tooltip>
        <ImageUploadForm
            ref="imageUpload"
            :imagePath="building.imagePath"
            @update="(v) => (file = v)"
            @uploadImage="uploadImage"
            @deleteImage="deleteImage"
            @updatedFilePath="filePath = $event"
            noButton
        />

      </v-col>
      <v-col>
        <h5 class="mb-0 font-weight-bold">
          <v-tooltip v-if="building.cutName" bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                {{ building.cutName }}
              </span>
            </template>
            {{ building.name }}
          </v-tooltip>
          <span v-else>{{ building.name }}</span>
        </h5>
      </v-col>
    </v-row>

    <v-form ref="form">
      <v-row v-show="!isMini" class="px-5" align="center">
        <v-col cols="12" class="pb-0">
          <!-- Name -->
          <v-text-field
              outlined
              v-model="building.name"
              :label="$t('common:name')"
              :rules="[ruleRequired($t('utils:rules.required'))]"
              clearable
              tabindex="1"
          />
        </v-col>
        <v-col cols="12" class="py-0">
          <!-- Object Number -->
          <v-text-field
              outlined
              v-model="building.objectNumber"
              :label="$t('common:object-number')"
              clearable
              tabindex="2"
          />
        </v-col>
        <v-col cols="12" class="py-0">
          <h4 class="primary--text font-weight-medium mt-5">{{ $t('common:address') }}</h4>

          <!-- Input Address -->
          <v-text-field
              outlined
              v-model="building.address_street"
              :label="$t('common:address')"
              clearable
              tabindex="3"
          />
        </v-col>
        <v-col cols="12" xl="6" class="py-0">
          <!-- Input ZIP -->
          <v-text-field
              outlined
              v-model="building.address_zip"
              :label="$t('common:zip')"
              clearable
              tabindex="4"
          />
        </v-col>
        <v-col cols="12" xl="6" class="py-0">
          <!-- Input City -->
          <v-text-field
              outlined
              v-model="building.address_city"
              :label="$t('common:city')"
              clearable
              tabindex="5"
          />
        </v-col>
        <v-col cols="12" xl="6" class="py-0">
          <!-- Input Select Country -->
          <v-select
              :items="restCountry"
              item-text="translatedName"
              item-value="id"
              :menu-props="{ bottom: true, offsetY: true }"
              v-model="building.country"
              outlined
              :label="$t('common:country')"
              @change="updateProvince"
              tabindex="6"
              clearable
          />
        </v-col>
        <v-col cols="12" xl="6" class="py-0">
          <!-- Input Select State -->
          <v-select
              :items="restProvince"
              item-text="translatedName"
              item-value="id"
              :menu-props="{ bottom: true, offsetY: true }"
              v-model="building.province"
              outlined
              :label="$t('common:province')"
              tabindex="7"
              clearable
          />
        </v-col>

        <v-col cols="12">
          <OpenStreetMap
              ref="map"
              :lat="building.latitude"
              :long="building.longitude"
              height="250"
              @changeLocation="changeLocation($event)"
          ></OpenStreetMap>
        </v-col>
        <v-col cols="12">
          <h4 class="primary--text font-weight-medium">{{ $t('book/building:common.organisation-info') }}</h4>
            <CustomerTypeahead
                ref="ownerTypeahead"
                :value="building.owner"
                @input="building.owner = $event"
                :label="$t('common:owner')"
                tabindex="8"
            />

            <CustomerTypeahead
                ref="operatorTypeahead"
                :value="building.operator"
                @input="building.operator = $event"
                :label="$t('common:operator')"
                tabindex="9"
            />
        </v-col>

        <v-col cols="12" class="pb-0">
          <BaseButton
              color="primary"
              :btn-text="$t('buttons:save-changes')"
              @clickedButton="saveBuilding"
          />
        </v-col>
        <v-col cols="12">
          <TwoButtonDialog
              v-if="!isAdmin"
              ref="deleteButton"
              :btn-text="$t('buttons:delete')"
              color="errorDark"
              :dialog-title="$t('dialog:delete-btn-title', {name : $t('book/building:building.form-sidebar.dialog-part-1')})"
              :dialog-text="$t('dialog:delete-btn-dialog', {name : $t('book/building:building.form-sidebar.dialog-part-2')})"
              :button1-text="$t('buttons:cancel')"
              :button2-text="$t('buttons:delete')"
              @clickedButton1="$refs.deleteButton.showDialog = false"
              @clickedButton2="deleteBuilding()"
          />

          <TwoButtonDialog
              v-if="restore"
              ref="restoreButton"
              :btn-text="$t('buttons:restore')"
              color="green"
              :dialog-title="$t('dialog:restore-btn-title', {name : $t('book/building:building.form-sidebar.dialog-part-1')})"
              :dialog-text="$t('dialog:restore-btn-dialog', {name : $t('book/building:building.form-sidebar.dialog-part-2')})"
              :button2-text="$t('buttons:restore')"
              :button1-text="$t('buttons:cancel')"
              @clickedButton1="$refs.restoreButton.showDialog = false"
              @clickedButton2="restoreBuilding()"
          />

          <ThreeButtonDialog
              ref="adminDeleteButton"
              v-if="isAdmin"
              color="errorDark"
              :btn-text="$t('buttons:delete')"
              :dialog-title="$t('dialog:delete-btn-title', {name : $t('book/building:building.form-sidebar.dialog-part-1')})"
              :dialog-text="$t('dialog:delete-btn-dialog', {name : $t('book/building:building.form-sidebar.dialog-part-2')})"
              :button1-text="$t('buttons:cancel')"
              :button2-text="$t('buttons:delete')"
              :button3-text="$t('dialog:delete-btn-3-text')"
              :hideFirstButton="restore"
              @clickedButton1="$refs.adminDeleteButton.showDialog = false;"
              @clickedButton2="deleteBuilding(false)"
              @clickedButton3="deleteBuilding(true)"

          />
        </v-col>
      </v-row>
    </v-form>
  </v-navigation-drawer>
</template>
<script>
import {ruleRequired, ruleLatitude, ruleLongitude} from "@/modules/core/services/rules";
import CountryService from "@/modules/core/services/country-service";
import BuildingService from "@/modules/book/services/building-service";

import GPSUtils from "@/modules/core/services/gps-utils";
import Utils from "@/modules/core/services/utils";

import Building from "@/modules/book/data/building";

import ImageUploadForm from "@/modules/core/components/ImageUploadForm";
import CustomerTypeahead from "@/modules/core/components/CustomerTypeAhead";
import TwoButtonDialog from "@/modules/core/components/TwoButtonDialog/TwoButtonDialog";
import ThreeButtonDialog  from "@/modules/core/components/TwoButtonDialog/ThreeButtonDialog";
import BaseButton from "@/modules/core/components/Base/BaseButton";

import {mapActions, mapState, mapGetters} from 'vuex'

export default {
  name: 'BuildingFormSidebar',
  components: {
    OpenStreetMap: () => import('@/modules/core/components/OpenStreetMap/OpenStreetMap'),
    ImageUploadForm,
    CustomerTypeahead,
    TwoButtonDialog,
    ThreeButtonDialog,
    BaseButton
  },
  data() {
    return {
      building: new Building(),
      restCountry: [],
      restProvince: [],
      restore: false,

      file: null,
      filePath: null,
    }
  },
  computed: {
    ...mapState('book/layout', {
      leftBuildingDrawer: state => state.leftBuildingDrawer
    }),
    ...mapGetters('auth', ['isAdmin']),
    LEFT_BUILDING_DRAWER_STATE: {
      get() {
        return this.leftBuildingDrawer
      },
      set(newValue) {
        if (newValue === this.leftBuildingDrawer) return;
        this.TOOGLE_LEFT_BUILDING_DRAWER_STATE();
      }
    },
    // property to determine if mini drawer is active
    isMini() {
      if(this.$vuetify.breakpoint.mdAndDown) {
        return this.LEFT_BUILDING_DRAWER_STATE
      } else {
        return !this.LEFT_BUILDING_DRAWER_STATE
      }
    },
    currentLang() {
      return this.$store.state.translation.language;
    },
  },
  watch: {
    currentLang() {
      Utils.sleep(500).then(() =>{
        Utils.translateAllCountries(this.restCountry);
        Utils.translateAllProvinces(this.restCountry,this.restProvince,this.building.country)
        this.$refs.form.resetValidation()
      })
    },

    'building.owner'(value) {
      if (value) {
        this.building.owner = value;
        this.$emit("setOwner", value);
      }
    },
    'building.operator'(value) {
      if (value) {
        this.building.operator = value;
        this.$emit("setOperator", value);
      }
    },
  },
  methods: {
    ...mapActions(
        'book/layout', ['TOOGLE_LEFT_BUILDING_DRAWER_STATE']
    ),
    addressToCoordinates() {
      GPSUtils.convertAddressToCoordinates(this.building.address_street, this.building.address_zip, this.building.address_city,
        (res) => {
          if(res.data.length > 0) {
            this.building.latitude = res.data[0].lat;
            this.building.longitude = res.data[0].lon
            if(this.$refs.map) {
              this.$refs.map.recenterMap(res.data[0].lat, res.data[0].lon);
              this.$refs.map.refreshMap();
            }
          } else {
            GPSUtils.getCoordinatesByZipCity(this.building.address_zip, this.building.address_city,
              (resp) => {
                if(resp.data.length > 0) {
                  this.building.latitude = resp.data[0].lat;
                  this.building.longitude = resp.data[0].lon
                  if(this.$refs.map) {
                    this.$refs.map.recenterMap(resp.data[0].lat, resp.data[0].lon);
                    this.$refs.map.refreshMap();
                  }
                } else {
                  Utils.showFailureSnackbar(this.$t('book/building:common.snackbar.gps-search'));
                }
              }
            )
          }
        },
        () => {
          Utils.showFailureSnackbar(this.$t('book/building:common.snackbar.gps-search'));
        }
      )
    },

    changeLocation(latlong) {
      this.building.latitude = latlong.lat;
      this.building.longitude = latlong.lng;
    },

    updateProvince() {
      if(!this.building.country) {
        return;
      }
      CountryService.readProvincesOfCountry(this.building.country,
        (res) => {
          this.restProvince = res.data;
          this.building.province = this.restProvince[0].id;
          Utils.translateAllProvinces(this.restCountry,this.restProvince,this.building.country);
        },
        (error) => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:province_plural')}))
          this.$logger.error(error);
        }
      )
    },

    getAllCountries() {
        CountryService.readAllFromAPI(
          (res) => {
            this.restCountry = res.data;
            Utils.translateAllCountries(this.restCountry);
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/building:common.snackbar.country')}))
            this.$logger.error(error);
          }
      )
    },

    ruleRequired,
    ruleLatitude,
    ruleLongitude,

    /**
     * Checks and uploads the currently set image.
     */
    uploadImage(fileForm) {
      //check if image exists
      if (!this.file || !fileForm.validate()) {
        return;
      }

      //upload
      BuildingService.uploadBuildingImage(this.building.id, this.file,
        () => {
          this.building.imagePath = this.filePath;
          this.$refs.imageUpload.setAlertSettings('success', this.$t("book/building:building.form-sidebar.snackbar.img-add-success"));
        },
        (error) => {
          this.$logger.error(error);
          this.$refs.imageUpload.setAlertSettings('error', this.$t("book/building:building.form-sidebar.snackbar.img-add-fail"));
        }
      )
      this.file = null;
    },

    /**
     * Deletes the currently set image.
     */
    deleteImage() {
      //check if image exists
      if (!this.building.imagePath) {
        return;
      }

      //delete
      BuildingService.deleteBuildingImage(this.building.id,
        () => {
          this.filePath = null;
          this.building.imagePath = null;
          this.$refs.imageUpload.setAlertSettings('success', this.$t("book/building:building.form-sidebar.snackbar.img-del-success"));
        },
        (error) => {
          this.$logger.error(error);
          this.$refs.imageUpload.setAlertSettings('error', this.$t("book/building:building.form-sidebar.snackbar.img-del-fail"));
        }
      )
    },

    deleteBuilding(softDelete) {
      if (this.isAdmin) {
        this.$refs.adminDeleteButton.setButtonSettings(true, true, false, true);
      } else {
        this.$refs.deleteButton.setButtonSettings(true, true, false, true);
      }

      BuildingService.deleteFromAPI(this.building, softDelete,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('common:building')}));
          this.$router.push(this.$store.state.book.routes.lastMainRoute)
        },
        (error) => {
          this.handleError(error);
          this.$refs.deleteButton.setButtonSettings(false, false, false, false);
          this.$refs.deleteButton.showDialog = false;
          Utils.showFailureSnackbar(this.$t('snackbar:delete-failure', {name: this.$t('common:building')}))
        }
      )
    },

    restoreBuilding() {
       this.$refs.restoreButton.setButtonSettings(true, true, false, true);

      BuildingService.restoreFromAPI(this.building,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:restore-success', {name: this.$t('common:building')}));
          this.$router.push(this.$store.state.book.routes.lastMainRoute)
        },
        (error) => {
          this.handleError(error);
          this.$refs.restoreButton.setButtonSettings(false, false, false, false);
          this.$refs.restoreButton.showDialog = false;
          Utils.showFailureSnackbar(this.$t('snackbar:restore-failure', {name: this.$t('common:building')}))
        }
      )
    },


    setFormData(building, restore) {
      this.building = building;
      if (this.building.imagePath) {
        this.building.imagePath = process.env.VUE_APP_ROOT_HOST + this.building.imagePath;
      }
      this.restore = restore;

      CountryService.readAllFromAPI(
          (res) => {
            this.restCountry = res.data;
            Utils.translateAllCountries(this.restCountry);

            this.$refs.ownerTypeahead.initialise(this.building.owner);
            this.$refs.operatorTypeahead.initialise(this.building.operator);

            if(!this.building.latitude && !this.building.longitude && this.building.address_street && this.building.address_zip && this.building.address_city) {
              this.addressToCoordinates();
            }

            if (this.building.country) {
              CountryService.readProvincesOfCountry(this.building.country,
                  (resP) => {
                    this.restProvince = resP.data;
                    Utils.translateAllProvinces(this.restCountry,this.restProvince,this.building.country)
                  },
                  (error) => {
                    Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:province_plural')}))
                    this.$logger.error(error);
                  }
              )
            }
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/building:common.snackbar.country')}))
            this.$logger.error(error);
          }
      )



    },

    saveBuilding() {
      this.$emit('save', this.building, this.$refs.form.validate())
    },
  }
}
</script>
